var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyReceiveCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.841 3.34678C26.1706 3.01736 26.1707 2.48313 25.8413 2.15354C25.5119 1.82394 24.9776 1.8238 24.648 2.15322L20.5744 6.22468L20.4626 3.30406C20.4448 2.83841 20.0529 2.47538 19.5872 2.4932C19.1216 2.51103 18.7586 2.90296 18.7764 3.36861L18.9088 6.828C18.9124 7.40332 19.0909 7.95816 19.5068 8.38142C19.9215 8.80341 20.4817 9.00269 21.0728 9.04536L21.0939 9.04662L24.6085 9.21165C25.074 9.23351 25.4691 8.87388 25.4909 8.4084C25.5128 7.94293 25.1531 7.54786 24.6877 7.52601L21.7954 7.3902L25.841 3.34678Z",
    fill: "url(#paint0_linear_5178_11084)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.90625 14.0124C1.90625 7.33912 7.32168 1.93097 14 1.93097C14.8271 1.93097 15.6358 2.01405 16.4177 2.1726C16.8744 2.26521 17.1695 2.7105 17.0769 3.1672C16.9843 3.6239 16.539 3.91905 16.0823 3.82644C15.4102 3.69015 14.7139 3.61847 14 3.61847C8.25191 3.61847 3.59375 8.27285 3.59375 14.0124C3.59375 19.7518 8.25191 24.4063 14 24.4063C19.748 24.4063 24.4062 19.7518 24.4062 14.0124C24.4062 13.2995 24.3345 12.6041 24.1981 11.9328C24.1054 11.4761 24.4004 11.0307 24.8571 10.938C25.3137 10.8452 25.7591 11.1402 25.8519 11.5969C26.0105 12.378 26.0938 13.1859 26.0938 14.0124C26.0938 20.6856 20.6783 26.0938 14 26.0938C7.32167 26.0938 1.90625 20.6856 1.90625 14.0124Z",
    fill: "url(#paint1_linear_5178_11084)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8.67328C14.466 8.67328 14.8438 9.05104 14.8438 9.51703V9.89204C15.7307 10.095 16.5137 10.6176 16.885 11.4045C17.0839 11.8259 16.9035 12.3288 16.482 12.5276C16.0606 12.7265 15.5578 12.546 15.3589 12.1246C15.2272 11.8455 14.7524 11.4845 14 11.4845C13.5434 11.4845 13.1625 11.6243 12.9149 11.8098C12.6675 11.9951 12.5938 12.1865 12.5938 12.3264C12.5938 12.4664 12.6675 12.6578 12.9149 12.8431C13.1625 13.0286 13.5434 13.1683 14 13.1683C14.786 13.1683 15.5302 13.406 16.0969 13.8306C16.6638 14.2553 17.0938 14.9068 17.0938 15.6977C17.0938 16.4887 16.6638 17.1402 16.0969 17.5649C15.7387 17.8333 15.3095 18.027 14.8438 18.1332V18.5072C14.8438 18.9731 14.466 19.3509 14 19.3509C13.534 19.3509 13.1562 18.9731 13.1562 18.5072V18.1321C12.2693 17.9291 11.4863 17.4066 11.115 16.6197C10.9161 16.1982 11.0965 15.6954 11.518 15.4966C11.9394 15.2977 12.4422 15.4781 12.6411 15.8996C12.7728 16.1787 13.2476 16.5396 14 16.5396C14.4566 16.5396 14.8375 16.3999 15.0851 16.2144C15.3325 16.0291 15.4062 15.8377 15.4062 15.6977C15.4062 15.5578 15.3325 15.3664 15.0851 15.1811C14.8375 14.9956 14.4566 14.8558 14 14.8558C13.214 14.8558 12.4698 14.6182 11.9031 14.1936C11.3362 13.7689 10.9062 13.1174 10.9062 12.3264C10.9062 11.5355 11.3361 10.884 11.9031 10.4592C12.2613 10.1909 12.6905 9.99718 13.1562 9.891V9.51703C13.1562 9.05104 13.534 8.67328 14 8.67328Z",
    fill: "url(#paint2_linear_5178_11084)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5178_11084",
    x1: 14,
    y1: 1.90625,
    x2: 14,
    y2: 26.0938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5856D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888EF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5178_11084",
    x1: 14,
    y1: 1.90625,
    x2: 14,
    y2: 26.0938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5856D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888EF1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5178_11084",
    x1: 14,
    y1: 1.90625,
    x2: 14,
    y2: 26.0938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5856D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#888EF1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyReceiveCircle);
export default __webpack_public_path__ + "static/media/money-receive-circle.7942bf63212c3719647b7621c1549008.svg";
export { ForwardRef as ReactComponent };